module.exports = __webpack_public_path__ + "static/media/tooltipIcon.1a402d19.svg";